export const CART_STORAGE_KEY = 'CART_ID';

export const JWT_STORAGE_KEY = 'JWT';
export const REFRESH_TOKEN_STORAGE_KEY = 'REFRESH_TOKEN';

export const LAST_VISITED_COUNTRY_STORAGE_KEY = 'LAST_VISITED_COUNTRY';
